module.exports = __webpack_public_path__ + "img/open-modal.dce6dea2.svg";